module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/42f546044da99b434f51cae4805df2b5.png";